const keyboardDatePickerFormEquipServType = {
  invalidDateMessage: 'Fecha en formato inválido.',
  maxDateMessage: 'La fecha no puede exceder el límite.'
};

export default keyboardDatePickerFormEquipServType;
